var render = function render(){
  var _vm$event, _vm$event2, _vm$event3, _vm$event4, _vm$event5, _vm$event6;
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('div', {
    staticClass: "custom-breadcrumb"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'Dashboard'
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('dashboard.tab.event')) + " ")]), _c('img', {
    staticClass: "mx-2",
    attrs: {
      "src": require("@/assets/customer-project/divider.svg")
    }
  }), _c('router-link', {
    attrs: {
      "to": {
        name: 'Event',
        params: {
          token: (_vm$event = _vm.event) === null || _vm$event === void 0 ? void 0 : _vm$event.id
        }
      }
    }
  }, [_vm._v(" " + _vm._s((_vm$event2 = _vm.event) === null || _vm$event2 === void 0 ? void 0 : _vm$event2.name) + " ")])], 1), _c('div', {
    staticClass: "event-header-layout"
  }, [_c('div', {
    staticClass: "event-main"
  }, [_c('router-link', {
    staticClass: "back-link",
    attrs: {
      "to": {
        name: 'Dashboard'
      }
    }
  }, [_c('font-awesome-icon', {
    staticClass: "back-arrow",
    attrs: {
      "icon": "arrow-left",
      "color": "#101828",
      "size": "lg"
    }
  })], 1), _c('div', {
    staticClass: "event-name"
  }, [_vm._v(" " + _vm._s((_vm$event3 = _vm.event) === null || _vm$event3 === void 0 ? void 0 : _vm$event3.name) + " ")]), _c('div', {
    staticClass: "event-meta"
  }, [_c('event-icon', {
    staticClass: "event-icon",
    attrs: {
      "event-type": (_vm$event4 = _vm.event) === null || _vm$event4 === void 0 ? void 0 : _vm$event4.type,
      "size": 44
    }
  }), _c('div', {
    staticClass: "project-name-badge"
  }, [_c('img', {
    attrs: {
      "src": require("@/assets/event-header/user.svg")
    }
  }), _c('span', [_vm._v(" " + _vm._s((_vm$event5 = _vm.event) === null || _vm$event5 === void 0 ? void 0 : _vm$event5.projectName) + " ")])])], 1)], 1), _c('div', {
    staticClass: "action-buttons"
  }, [_c('b-button', {
    attrs: {
      "variant": "primary"
    },
    on: {
      "click": _vm.onClick
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('event.editors')) + " ")]), _vm.$route.name === 'Event' ? _c('b-button', {
    attrs: {
      "variant": "primary"
    },
    on: {
      "click": _vm.showDuplicateModal
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('event.duplicate')) + " ")]) : _vm._e(), _vm.$route.name === 'Event' ? _c('b-button', {
    attrs: {
      "variant": "primary"
    },
    on: {
      "click": _vm.showImportModal
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('event.import')) + " ")]) : _vm._e(), _vm.$route.name === 'Event' ? _c('b-button', {
    attrs: {
      "variant": "primary"
    },
    on: {
      "click": _vm.showNewItemModal
    }
  }, [_c('font-awesome-icon', {
    staticClass: "mr-1",
    attrs: {
      "icon": "plus",
      "size": "sm"
    }
  }), _c('span', [_vm._v(" " + _vm._s(_vm.$t('event.new-item')) + " ")])], 1) : _vm._e()], 1)]), _c('b-row', {
    staticClass: "mx-0 mb-2"
  }, [_c('toggleable-text', {
    staticClass: "event-details",
    attrs: {
      "text": (_vm$event6 = _vm.event) === null || _vm$event6 === void 0 ? void 0 : _vm$event6.description
    }
  })], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }